

<div class="flex p-1 gap-2 text-center">
    <img src="assets/images/icons/lamella.svg" width="24" height="24" alt="lamella"/>
    <h6 class="text-gray-500 font-semibold uppercase self-center">
        @if(type() == "LAMELLA"){
            {{ "LAMELLA" | translate }}
        }
        @else {
            {{ "QUANTITY.MOUNTING_PROFILE" | translate }}
        }
    </h6>
</div>

<hr class="h-0.5 border-t-0 bg-gray-500"/>

<div class="w-full">
    @for (lamellaProfile of groupedCuttingPlan(); track lamellaProfile.id; let i = $index) {
        <div class="flex gap-2">
            <div class="self-center text-nowrap text-xs text-gray-500 font-semibold translate-y-[75%]">
                {{lamellaProfile.count}} X
            </div>

            <div class="w-full">
                @if(i > 0) {
                    <div class="w-full"  [style.page-break-before]="(i+1)%16===0 && (i+1) !== cuttingPlan().profiles.length ? 'always' : null"></div>
                }
                <div class="w-full text-xs text-gray-500 mt-2">
                    {{ "PRODUCT_CARD.LAMELLA_SET.PROFILE" | translate}}:
                    @if(lamellaProfile.count>1){ {{lamellaProfile.id}} - {{lamellaProfile.id+lamellaProfile.count-1}} }@else{ {{lamellaProfile.id}} }.
                    {{ lamellaProfile.pieces[0].productCode }},
                    {{ "GLOBAL.DELIVERY_LENGTH"| translate}} : {{ cuttingPlan().profileLength }} mm,
                    {{ "CUTTING_PLAN.USAGE_LENGTH"| translate}} : {{piecesTotalLength(lamellaProfile)}} mm,
                    {{ "CUTTING_PLAN.WASTE_LENGTH"| translate}} : {{lamellaProfile.leftover}} mm,
                </div>
                <div class="w-full flex border gap-0" [style.background-color]="lamellaProfile.pieces[0].color">


                    @for (piece of lamellaProfile.pieces; track $index; let last = $last) {
                        <div
                                [style.width.%]="countWidth(piece.length)"
                                [style.background-color]="piece.color"

                                class="flex items-center justify-center text-center p-2 text-white overflow-hidden border-dashed border-white border-r-4 box-border"

                        >
                            <div class="flex flex-col items-center text-xs">
                                <span>{{ piece.length }} mm</span>
                            </div>
                        </div>
                    }

                    @if (showOverflow(lamellaProfile)) {

                        <div
                                [style.width.%]="countWidth(lamellaProfile.leftover)"
                                class="bg-gray-200 text-gray-700 flex items-center justify-center text-center p-2 overflow-hidden">
                            <div class="flex flex-col items-center text-xs">

                        <span class="whitespace-nowrap">{{"GLOBAL.OVERFLOW" | translate}}: {{ lamellaProfile.leftover }}
                            mm</span>
                            </div>
                        </div>
                    }

                </div>


            </div>
        </div>
    }
</div>

@if (cuttingPlanFrame().profiles && cuttingPlanFrame().profiles.length > 0){

<div class="flex p-1 gap-2 text-center mt-12" [style.page-break-before]="'always'" >
    <img src="assets/images/icons/lamella.svg" width="24" height="24" alt="lamella"/>
    <h6 class="text-gray-500 font-semibold uppercase self-center">
        {{ "QUANTITY.FRAME_PROFILE" | translate}}
    </h6>
</div>

<hr class="h-0.5 border-t-0 bg-gray-500"/>

<div class="w-full">
    @for (lamellaProfile of groupedCuttingPlan(); track lamellaProfile.id) {
        <div class="flex gap-2">
            <div class="self-center text-nowrap text-xs text-gray-500 font-semibold translate-y-[75%]">
                {{lamellaProfile.count}} X
            </div>
            <div class="w-full">
                <div class="w-full text-xs text-gray-500 mt-2">
                    {{ "PRODUCT_CARD.LAMELLA_SET.PROFILE" | translate}}: {{ lamellaProfile.id }}. {{ lamellaProfile.pieces[0].productCode }}, {{ "GLOBAL.DELIVERY_LENGTH"| translate}} : {{ cuttingPlan().profileLength }} mm,
                    {{ "CUTTING_PLAN.USAGE_LENGTH"| translate}} : {{piecesTotalLength(lamellaProfile)}} mm,
                    {{ "CUTTING_PLAN.WASTE_LENGTH"| translate}} : {{lamellaProfile.leftover}} mm,
                </div>
                <div class="w-full flex border gap-0" [style.background-color]="lamellaProfile.pieces[0].color">


                    @for (piece of lamellaProfile.pieces; track $index; let last = $last) {
                        <div
                                [style.width.%]="countWidth(piece.length)"
                                [style.background-color]="piece.color"

                                class="flex items-center justify-center text-center p-2 text-white overflow-hidden border-dashed border-white border-r-4 box-border"

                        >
                            <div class="flex flex-col items-center text-xs">
                                <span>{{ piece.length }} mm</span>
                            </div>
                        </div>
                    }

                    @if (showOverflow(lamellaProfile)) {

                        <div
                                [style.width.%]="countWidth(lamellaProfile.leftover)"
                                class="bg-gray-200 text-gray-700 flex items-center justify-center text-center p-2 overflow-hidden">
                            <div class="flex flex-col items-center text-xs">

                                <span class="whitespace-nowrap">{{"GLOBAL.OVERFLOW" | translate}}: {{ lamellaProfile.leftover }}
                                    mm</span>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </div>
    }
</div>
}


@if("MOUNTING_AND_FRAME" == type()){
    <span class="space-y-8 italic divide-gray-500">{{"CUTTING_PLAN.NOTICE_TEXT" | translate}}</span>
}